import { render } from "./ActiveDepositComponent.vue?vue&type=template&id=61d0fd16&scoped=true"
import script from "./ActiveDepositComponent.vue?vue&type=script&lang=js"
export * from "./ActiveDepositComponent.vue?vue&type=script&lang=js"

import "./ActiveDepositComponent.vue?vue&type=style&index=0&id=61d0fd16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d0fd16"]])

export default __exports__